import { z } from 'zod';
import { ConsumableUseContext, EquipmentSlot, ItemLocationType, } from '../entity/types.js';
import { EquipmentSpriteOverridesSchema } from './characterDef.schema.js';
import { DiscoveryStateSchema } from './place.schema.js';
export const EquipmentSlotSchema = z.nativeEnum(EquipmentSlot);
export const ItemLocationTypeSchema = z.nativeEnum(ItemLocationType);
export const ItemIconSchema = z.object({
    atlas: z.string(),
    frame: z.string(),
});
export const ConsumableUseContextSchema = z.nativeEnum(ConsumableUseContext);
export const ConsumableEffectSchema = z.object({
    type: z.string(),
    params: z.record(z.string(), z.string()),
});
export const ConsumableDefSchema = z.object({
    useContext: ConsumableUseContextSchema,
    usesTurn: z.boolean(),
    effects: z.array(ConsumableEffectSchema),
    useText: z.string(),
});
export const ItemDefSchema = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string(),
    slot: EquipmentSlotSchema,
    icon: ItemIconSchema,
    grantedAbilities: z.array(z.string()),
    armor: z.number().int().min(0).optional(),
    spriteOverrides: EquipmentSpriteOverridesSchema.optional(),
    isQuestItem: z.boolean().optional(),
    value: z.number().int().min(0),
    characterId: z.string().optional(),
    consumable: ConsumableDefSchema.optional(),
});
export const ItemLocationSchema = z.object({
    type: ItemLocationTypeSchema,
    id: z.string().optional(),
});
export const ItemInstanceSchema = z.object({
    id: z.string(),
    defId: z.string(),
    characterId: z.string(),
    discoveryState: DiscoveryStateSchema,
    history: z.array(z.string()),
    location: ItemLocationSchema,
    quantity: z.number().int().min(1),
});
export const ItemInstanceDTOSchema = ItemInstanceSchema.extend({
    def: ItemDefSchema,
});
// Equipment = slot → equipped instance id (or null/absent). The full item data
// is resolved from the inventory `IItemInstanceDTO[]` by id on the client.
export const EquipmentSlotsSchema = z.object({
    head: z.string().nullable().optional(),
    body: z.string().nullable().optional(),
    mainHand: z.string().nullable().optional(),
    offHand: z.string().nullable().optional(),
    accessory: z.string().nullable().optional(),
});
export const InventoryDropRequestSchema = z.object({
    characterId: z.string(),
    instanceId: z.string(),
});
export const InventoryDropResponseSchema = z.object({
    inventory: z.array(ItemInstanceDTOSchema),
});
export const EquipRequestSchema = z.object({
    characterId: z.string(),
    instanceId: z.string(),
    slot: EquipmentSlotSchema,
});
export const UnequipRequestSchema = z.object({
    characterId: z.string(),
    slot: EquipmentSlotSchema,
});
export const EquipResponseSchema = z.object({
    inventory: z.array(ItemInstanceDTOSchema),
    equipment: EquipmentSlotsSchema,
    abilities: z.array(z.string()),
    spriteHash: z.string().optional(),
});
